var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show-hide-delay",rawName:"v-show-hide-delay",value:(_vm.shown),expression:"shown"}],staticClass:"loader"})}
var staticRenderFns = []

export { render, staticRenderFns }